<script setup lang="ts">
import { computed } from "vue";

import { useArtStore } from "@/store/art";

defineEmits<{ submit: [text: string] }>();

const artStore = useArtStore();

const questionKeys = computed(() => [
  // The first question is different for single- and multi-ART sessions.
  artStore.isMultiArt
    ? /*$t*/ "sightline.suggestionCrossArtDependencies"
    : /*$t*/ "sightline.suggestionStoriesWithoutObjective",
  /*$t*/ "sightline.suggestionFeaturesBlocked",
  /*$t*/ "sightline.suggestionDependenciesNotDone",
  /*$t*/ "sightline.suggestionObjectivesWithoutWork",
]);
</script>

<template>
  <div class="suggestions">
    <p class="description">{{ $t("sightline.suggestionsDescription") }}</p>
    <button
      v-for="key in questionKeys"
      :key
      class="suggestion"
      type="button"
      @click="$emit('submit', $t(key))"
    >
      {{ $t(key) }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.suggestions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 16px;

  .description {
    @include typography.medium("regular");

    margin: 0 0 16px;
    color: colors.$text-subtle;
    line-height: 1.5;
  }

  .suggestion {
    @include typography.medium("regular");

    width: 100%;
    padding: 10px 12px;
    border: 1px solid colors.$border-light;
    border-radius: 8px;
    color: colors.$text;
    text-align: left;
    line-height: 1.4;
    overflow-wrap: break-word;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      background: colors.$background-grey;
    }
  }
}
</style>
